import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { DomainGq, DomainGqProps } from '../models/DomainGq';

export function useGetDomainsGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getDomains?.domains ?? [],
  };
}

const gqTag = gql`
  query DomainsGetAll($command: GetDomainsCommand!) {
    projects {
      getDomains(command: $command) {
        domains {${DomainGqProps}}
      }
    }
  }
`;

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
}

interface GQLData {
  readonly projects: {
    readonly getDomains: {
      readonly domains: DomainGq[];
    };
  };
}
